import { render, staticRenderFns } from "./duoTrainingTile.vue?vue&type=template&id=539cfd4c&"
import script from "./duoTrainingTile.vue?vue&type=script&lang=js&"
export * from "./duoTrainingTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports